import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const MicrosoftTeamsIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_13309_8570)">
        <path
          d="M11.7647 7.38281H15.3809C15.7226 7.38281 15.9995 7.65977 15.9995 8.00141V11.2953C15.9995 12.551 14.9817 13.5689 13.726 13.5689H13.7153C12.4596 13.569 11.4416 12.5513 11.4414 11.2956C11.4414 11.2955 11.4414 11.2954 11.4414 11.2953V7.70612C11.4414 7.52756 11.5862 7.38281 11.7647 7.38281Z"
          fill="#5059C9"
        />
        <path
          d="M14.2073 6.73297C15.0165 6.73297 15.6724 6.07701 15.6724 5.26785C15.6724 4.45869 15.0165 3.80273 14.2073 3.80273C13.3981 3.80273 12.7422 4.45869 12.7422 5.26785C12.7422 6.07701 13.3981 6.73297 14.2073 6.73297Z"
          fill="#5059C9"
        />
        <path
          d="M9.65144 6.73256C10.8202 6.73256 11.7677 5.78507 11.7677 4.61628C11.7677 3.44749 10.8202 2.5 9.65144 2.5C8.48265 2.5 7.53516 3.44749 7.53516 4.61628C7.53516 5.78507 8.48265 6.73256 9.65144 6.73256Z"
          fill="#7B83EB"
        />
        <path
          d="M12.4733 7.38281H6.50405C6.16647 7.39117 5.89943 7.67132 5.90726 8.00891V11.7658C5.86012 13.7916 7.46287 15.4728 9.48866 15.5224C11.5144 15.4728 13.1172 13.7916 13.0701 11.7658V8.00891C13.0779 7.67132 12.8108 7.39117 12.4733 7.38281Z"
          fill="#7B83EB"
        />
        <path
          opacity="0.1"
          d="M9.8134 7.38281V12.6475C9.81178 12.8889 9.66548 13.1058 9.44224 13.1977C9.37116 13.2278 9.29477 13.2433 9.21759 13.2433H6.19293C6.15061 13.1358 6.11154 13.0284 6.07898 12.9177C5.96501 12.5441 5.90686 12.1557 5.90642 11.7651V8.00793C5.89859 7.67088 6.1652 7.39117 6.50223 7.38281H9.8134Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M9.48782 7.38281V12.973C9.48781 13.0502 9.47231 13.1266 9.44224 13.1977C9.35032 13.4209 9.13343 13.5672 8.89201 13.5689H6.34596C6.29061 13.4614 6.23852 13.354 6.19293 13.2433C6.14735 13.1326 6.11154 13.0284 6.07898 12.9177C5.96501 12.5441 5.90686 12.1557 5.90642 11.7651V8.00793C5.89859 7.67088 6.1652 7.39117 6.50223 7.38281H9.48782Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M9.48782 7.38281V12.3219C9.48533 12.6499 9.22003 12.9152 8.892 12.9177H6.07898C5.96501 12.5441 5.90686 12.1557 5.90642 11.7651V8.00793C5.89859 7.67088 6.1652 7.39117 6.50223 7.38281H9.48782Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M9.16223 7.38281V12.3219C9.15975 12.6499 8.89445 12.9152 8.56642 12.9177H6.07898C5.96501 12.5441 5.90686 12.1557 5.90642 11.7651V8.00793C5.89859 7.67088 6.1652 7.39117 6.50223 7.38281H9.16223Z"
          fill="black"
        />
        <path
          opacity="0.1"
          d="M9.81422 5.70128V6.72686C9.75887 6.73011 9.70678 6.73337 9.65143 6.73337C9.59608 6.73337 9.54399 6.73012 9.48863 6.72686C9.37874 6.71957 9.26974 6.70213 9.16305 6.67477C8.50375 6.51863 7.95906 6.05625 7.69794 5.43105C7.65301 5.32606 7.61813 5.21704 7.59375 5.10547H9.2184C9.54694 5.10671 9.81297 5.37273 9.81422 5.70128Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M9.48991 6.0255V6.7255C9.38002 6.7182 9.27102 6.70077 9.16434 6.67341C8.50503 6.51727 7.96034 6.05489 7.69922 5.42969H8.8941C9.22264 5.43093 9.48866 5.69696 9.48991 6.0255Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M9.48991 6.0255V6.7255C9.38002 6.7182 9.27102 6.70077 9.16434 6.67341C8.50503 6.51727 7.96034 6.05489 7.69922 5.42969H8.8941C9.22264 5.43093 9.48866 5.69696 9.48991 6.0255Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M9.16434 6.0255V6.67341C8.50503 6.51727 7.96034 6.05489 7.69922 5.42969H8.56852C8.89707 5.43094 9.16309 5.69696 9.16434 6.0255Z"
          fill="black"
        />
        <path
          d="M2.59679 5.42969H8.566C8.8956 5.42969 9.16278 5.69688 9.16278 6.02648V11.9957C9.16278 12.3253 8.89559 12.5925 8.566 12.5925H2.59679C2.26719 12.5925 2 12.3253 2 11.9957V6.02648C2 5.69688 2.26719 5.42969 2.59679 5.42969Z"
          fill="url(#paint0_linear_13309_8570)"
        />
        <path
          d="M7.15293 7.70259H5.95967V10.9519H5.19944V7.70259H4.01172V7.07227H7.15293V7.70259Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_13309_8570"
          x1="3.24432"
          y1="4.96337"
          x2="7.91847"
          y2="13.0588"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A62C3" />
          <stop offset="0.5" stopColor="#4D55BD" />
          <stop offset="1" stopColor="#3940AB" />
        </linearGradient>
        <clipPath id="clip0_13309_8570">
          <rect
            width="14"
            height="13.0233"
            fill="white"
            transform="translate(2 2.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MicrosoftTeamsIcon;
